"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FlushingControl = void 0;
var _react = _interopRequireWildcard(require("react"));
var _paulCorePackage = require("paul-core-package");
var _material = require("@mui/material");
var _reactRedux = require("react-redux");
var _FlushingPanel = _interopRequireDefault(require("./FlushingPanel"));
var _FlushingControlModule = _interopRequireDefault(require("../../styles/components/Flushing/FlushingControl.module.css"));
var _History = _interopRequireDefault(require("./History"));
var _selectors = require("../../redux/selectors");
var _FlushTabs = _interopRequireDefault(require("./FlushTabs"));
var _constants = require("../../utils/constants");
var _reducers = require("../../redux/reducers");
var _sagas = _interopRequireDefault(require("../../redux/sagas"));
var _useSetActiveFilter = _interopRequireDefault(require("../../hooks/useSetActiveFilter"));
var _StatusTag = _interopRequireDefault(require("./StatusTag"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/** @todo refactoring*/
const FlushingPanelWrap = () => {
  const activeDeviceId = (0, _reactRedux.useSelector)(_selectors.selectActiveDeviceId) || null;
  return /*#__PURE__*/_react.default.createElement(_FlushingPanel.default, {
    className: _FlushingControlModule.default.panel,
    thingPDIDDevice: activeDeviceId
  });
};
const FlushingControlContent = /*#__PURE__*/(0, _react.memo)(() => {
  const hasActiveFilter = Boolean((0, _reactRedux.useSelector)(_selectors.selectActiveDeviceId));
  const hasData = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.selectHasData);
  (0, _useSetActiveFilter.default)();
  if (!hasData) {
    return /*#__PURE__*/_react.default.createElement(_material.Box, {
      sx: {
        maxWidth: 1052,
        width: '100%'
      },
      className: "flex-center"
    }, /*#__PURE__*/_react.default.createElement(_material.CircularProgress, null));
  }
  if (!hasActiveFilter) return null;
  return /*#__PURE__*/_react.default.createElement(_paulCorePackage.Card, {
    sx: {
      maxWidth: 1052,
      height: 563,
      width: '100%'
    },
    title: "Backflush filter",
    showCloseBtn: false,
    className: "flex-column ".concat(_FlushingControlModule.default.card),
    customIcon: /*#__PURE__*/_react.default.createElement(_StatusTag.default, null)
  }, /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "flex-column flex-left-center w-100 flex-between ".concat(_FlushingControlModule.default.wrap)
  }, /*#__PURE__*/_react.default.createElement(_FlushTabs.default, null), /*#__PURE__*/_react.default.createElement(_material.Box, {
    className: "flex-row flex-left-center flex-top-center h-100 ".concat(_FlushingControlModule.default.content)
  }, /*#__PURE__*/_react.default.createElement(FlushingPanelWrap, null), /*#__PURE__*/_react.default.createElement("hr", {
    className: _FlushingControlModule.default.hr
  }), /*#__PURE__*/_react.default.createElement(_History.default, null))));
});
const FlushingControl = () => {
  (0, _paulCorePackage.useInjectStore)({
    key: _constants.packageKey,
    reducer: {
      reducers: _reducers.reducers
    },
    saga: _sagas.default
  });
  return /*#__PURE__*/_react.default.createElement(FlushingControlContent, null);
};
exports.FlushingControl = FlushingControl;